<template>
  <v-container class="cmpbk black--text" id="admin-container">
    <template v-if="logged_in">
      <v-btn color="white" class="mb-4" @click="get_csv">
        Export CSV
      </v-btn>

      <v-data-table
        :headers="hdrs"
        :items="records"
        dense
        class="elevation-1"
      >
        <template v-slot:item.amount="{ item }">
          <span v-if="item.amount !== null && item.amount !== ''">
            ${{ Number(item.amount).toFixed(2) }}
          </span>
        </template>
      </v-data-table>
    </template>

    <template v-else>
      <v-text-field
      dark
      class="light-blue--text"
        v-model="peeduhbu"
        label="Admin code"
      ></v-text-field>

      <v-btn color="primary" @click="go">
        Enter
      </v-btn>
    </template>
  </v-container>
</template>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

export default {
  name: "admin",
  mixins: [bus_common],

  data() {
    return {
      records: [],
      logged_in: false,
      peeduhbu: "",
      emaildate: "#99Yvette#",

      hdrs: [
        { text: "Type", value: "recordType", width: 130 },
        { text: "ID", value: "id", width: 90 },
        { text: "Name", value: "name", width: 180 },
        { text: "Email", value: "email", width: 220 },
        { text: "Phone", value: "phone", width: 140 },
        { text: "Address", value: "address", width: 220 },
        { text: "Status", value: "status", width: 90 },
        { text: "Amount", value: "amount", width: 110 },
        { text: "Participation", value: "participationType", width: 140 },
        { text: "Distance", value: "distance", width: 120 },
        { text: "Mode", value: "mode", width: 120 },
        { text: "Volunteer Preference", value: "positionPreference", width: 220 },
        { text: "Heard From", value: "hear", width: 160 },
        { text: "Created", value: "created", width: 140 },
      ],
    };
  },

  methods: {
    get_csv() {
      //window.location.assign("http://localhost:5000/get_csv");
      window.location.assign("https://13soulsrun.org/get_csv");
    },

    get_records() {
      var formIn = {};
      formIn.apiname = "get_records";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.records = this.mno(data);

          for (let index = 0; index < self.records.length; index++) {
            const element = self.records[index];

            if (element.created) {
              element.created = self.format_date_us(element.created);
            }

            if (element.recordType === "Volunteer") {
              element.amount = "";
            }
          }
        })
        .catch((msg) => {
          self.show_loader(false);
          self.swall_it("Error", msg, "error", null, null);
        });
    },

    go() {
      if (this.peeduhbu == this.emaildate) {
        this.logged_in = true;
        this.get_records();
      }
    },

    init() {
      this.show_loader(false);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>

<style scoped>
#admin-container {
  max-width: 98%;
}
</style>